define([
        'jquery',
        'jquery.cookie',
        'handlebars-core',
        'foundation.reveal',
    ], function($, cookie, handlebarsCore, foundation) {

        /*
         VFDP-81726 -- Geolocation Redirect
           Checks users current reported Edgescape country against provided datalayer
           If they differ, request the location selector modal
        */

        'use strict';

        var DEBUG = false,
            PLUGIN_IDENTIFIER = 'geoModal';

        if ( DEBUG ) console.log('geoModal file loaded');

        var	geoModal = function( element, options ) {
            this.pluginID = PLUGIN_IDENTIFIER;

            this.element = element;

            this.$element = $(this.element);

            this.options = options || {};

            this.metadata = $(this.element).data('options');
        };

        geoModal.prototype = {
            init: function(){
                var $modal = $('#geo-location-modal');
                if($modal && $modal.length > 0){
                    var $urlMeta = $('meta[name="geoModalPath"]');
                    if($urlMeta && $urlMeta.length > 0 && $urlMeta.attr("content")){
                        var modalPath = $urlMeta.attr("content");
                        if($.cookie && dataLayer && dataLayer[0]) {
                            var edgeScapeCountry = $.cookie("Edgescape-Country");
                            var dataLayerCountry = dataLayer[0].country;
                            var modalPrevDisplayed = $.cookie("Geo-Modal-Displayed");
                            if(!modalPrevDisplayed && edgeScapeCountry && dataLayerCountry) {
                                if (edgeScapeCountry !== dataLayerCountry) {
                                    if(modalPath) {
                                        $.ajax(modalPath).done(function (resp) {
                                            $modal.html(resp).foundation('open');
                                            //if they do not navigate, do not set cookie
                                            $.cookie("Geo-Modal-Displayed", true);
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };

        geoModal.prototype = $.extend({}, handlebarsCore, geoModal.prototype);

        // prevent duplicate instantiation
        $.fn.geoModal = function(options) {
            return this.each(function() {
                var instance = $(this).data(PLUGIN_IDENTIFIER);
                if(!instance) {
                    instance = new geoModal(this, options).init();
                    $(this).data(PLUGIN_IDENTIFIER,instance);
                }
            });
        };

        return geoModal;
    }
);